import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=1f159b26&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"
import style0 from "./styles/language.css?vue&type=style&index=0&id=1f159b26&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f159b26",
  null
  
)

export default component.exports